import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import { useSelector } from "react-redux";
import { useAssetTypeImageTypes } from "../../../hooks";
import useImageTypes from "../../PhotoList/useImageTypes";
import styles from "./styles";

import ActionBar from "../../ActionBar";
import {
    Button,
    Grid,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Box,
} from "@mui/material/";
import SaveIcon from "@mui/icons-material/Save";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";

type Props = {
    onRetakePhoto: Function,
    onSuccess: Function,
    photosCount: int,
    photo: any,
};

// TODO: this should come from the org API
// Sequence: VIN, Whole Vehicle, Reg, Odometer, Damage
// Assumption assetImageTypes order don't change
const photoSequence = [0, 2, 1, 3, 4];

/**
 * Save Photo Component
 */
export default ({
    disableImageType,
    assetTypeId,
    onRetakePhoto,
    onSuccess,
    photo,
    photosCount,
    exclusionReasonTypeId,
}: Props) => {
    const { typesList } = useSelector((state) => state);
    const assetImageTypes = useAssetTypeImageTypes(assetTypeId);
    const imageTypes = useImageTypes(assetImageTypes, exclusionReasonTypeId);
    const classes = makeStyles(styles)();
    const { t } = useTranslation();

    // Check that imageTypeId can be mapped with available imageTypes
    const imageTypeId =
        photoSequence[photosCount] !== undefined &&
        imageTypes[photoSequence[photosCount]] !== undefined
            ? photoSequence[photosCount]
            : imageTypes.length - 1;

    const [imageType, setImageType] = useState(imageTypes[imageTypeId].id);

    const onSavePhotoPress = () => onSuccess && onSuccess(imageType);

    const onImageTypeChange = (e: any) => {
        const { value } = e.target;
        setImageType(value);
    };

    // map exclusion reason with image type
    useEffect(() => {
        if (exclusionReasonTypeId) {
            const typeObj = typesList.exclusionImageTypes.data.find(
                (item) => item.exclusionReasonId == exclusionReasonTypeId
            );

            if (typeObj && Object.keys(typeObj).length > 0)
                setImageType(typeObj.imageTypeId);
        }
    }, [exclusionReasonTypeId]);

    const RetakePhoto = () => (
        <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onRetakePhoto}
            endIcon={<PhotoCameraIcon />}
        >
            {t("retakePhoto")}
        </Button>
    );

    const SavePhoto = () => (
        <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={onSavePhotoPress}
            endIcon={<SaveIcon />}
        >
            {t("savePhoto")}
        </Button>
    );

    return (
        <div className={classes.wrapper}>
            <Box className={classes.padding}>
                {!disableImageType && (
                    <FormControl fullWidth>
                        <InputLabel id="image-type-select-label">
                            {t("imageType")}
                        </InputLabel>
                        <Select
                            id="image-type-select"
                            value={imageType}
                            label={t("imageType")}
                            onChange={onImageTypeChange}
                            data-testid={"picker"}
                        >
                            {imageTypes.map((item, index) => (
                                <MenuItem
                                    value={item.id}
                                    key={index}
                                    className={classes.menuItem}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                <div className={classes.previewWrp}>
                    <img
                        src={photo.imageUrl}
                        alt="photo"
                        className={classes.imagePreview}
                    />
                </div>
            </Box>
            <ActionBar>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <RetakePhoto />
                    </Grid>
                    <Grid item xs={6}>
                        <SavePhoto />
                    </Grid>
                </Grid>
            </ActionBar>
        </div>
    );
};
